
import { getDateString, secondsToDate, secondsToDateString } from "../../utils/DateTimeUtils"
import { Dexiedb } from "../Dexiedb"

export const TeleLocalDb = {
    async deleteTelelocalMessages(chatIds: string[], fromDate: string, toDate: string) {
        for (let chatId of chatIds) {
            let messages = await Dexiedb.instance.messages
                .where('chatId')
                .equals(chatId)
                .and((message) => {
                    let date = secondsToDateString(message.date);
                    if (date >= fromDate && date <= toDate) {
                        return true;
                    }
                    else return false;
                }).toArray();

            messages.forEach(async (message) => {

                await Dexiedb.instance.messages.delete([message.chatId, message.id]);
                console.log("Deleted message: ", message);

            });
            let messagesTelegram = await Dexiedb.instance.telegramMessage
                .where('chatId')
                .equals(Number(chatId))
                .and((message) => {
                    let date = secondsToDateString(message.date);
                    if (date >= fromDate && date <= toDate) {
                        return true;
                    }
                    else return false;
                }).toArray();

            messagesTelegram.forEach(async (message) => {
                // const key = [message.chatId, message.messageId];
                // const found = await Dexiedb.instance.telegramMessage.where('[chatId+messageId]').equals(key).first();
                // console.log("Before delete found = ", found);

                await Dexiedb.instance.telegramMessage
                    .where('[chatId+messageId]')
                    .equals([message.chatId, message.messageId])
                    .delete();
                console.log("Deleted messageTele: ", message);

            });
        }

    }
}